import React, { useState, useEffect } from 'react';
import './DashboardProfile.css';
import { API_BASE } from '../utils/apiBase';

export default function DashboardProfile({ userProfile, token, userEmail, onProfileUpdate }) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [formData, setFormData] = useState({
    name: userProfile?.name || '',
    phone: userProfile?.phone || '',
    company: userProfile?.company || '',
    acceptsPromos: userProfile?.acceptsPromos || false
  });

  // Sincronizar formData com userProfile quando ele mudar
  useEffect(() => {
    console.log('[DashboardProfile] Props recebidas:', {
      userProfile,
      userEmail,
      token: token ? 'presente' : 'ausente'
    });
    setFormData({
      name: userProfile?.name || '',
      phone: userProfile?.phone || '',
      company: userProfile?.company || '',
      acceptsPromos: userProfile?.acceptsPromos || false
    });
  }, [userProfile, userEmail]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      const res = await fetch(`${API_BASE}/api/auth/profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        setMessage('✅ Perfil atualizado com sucesso!');
        setEditing(false);
        
        // Atualizar dados do perfil no Dashboard
        if (onProfileUpdate) {
          console.log('[DashboardProfile] Atualizando perfil no Dashboard...');
          await onProfileUpdate();
        }
        
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('❌ Erro ao atualizar perfil');
      }
    } catch (err) {
      setMessage('❌ Erro de conexão');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: userProfile?.name || '',
      phone: userProfile?.phone || '',
      company: userProfile?.company || '',
      acceptsPromos: userProfile?.acceptsPromos || false
    });
    setEditing(false);
    setMessage('');
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">
          <div className="avatar-circle">
            {(formData.name || userProfile?.email || userEmail || 'U').charAt(0).toUpperCase()}
          </div>
        </div>
        <div className="profile-header-info">
          <h2>{formData.name || 'Usuário'}</h2>
          <p className="profile-email">{userProfile?.email || userEmail || 'Email não disponível'}</p>
        </div>
      </div>

      {message && (
        <div className={`profile-message ${message.startsWith('✅') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="profile-form">
        <div className="form-section">
          <h3>📋 Informações Pessoais</h3>
          
          <div className="form-group">
            <label>Nome Completo</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={!editing}
              placeholder="Seu nome completo"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Telefone</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                disabled={!editing}
                placeholder="(00) 00000-0000"
              />
            </div>

            <div className="form-group">
              <label>Empresa</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                disabled={!editing}
                placeholder="Nome da empresa"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>⚙️ Preferências</h3>
          
          <div className="form-checkbox">
            <input
              type="checkbox"
              id="acceptsPromos"
              name="acceptsPromos"
              checked={formData.acceptsPromos}
              onChange={handleChange}
              disabled={!editing}
            />
            <label htmlFor="acceptsPromos">
              <strong>Aceitar promoções e novidades</strong>
              <span>Receba emails com ofertas exclusivas e atualizações</span>
            </label>
          </div>
        </div>

        <div className="profile-actions">
          {!editing ? (
            <button
              type="button"
              className="btn-edit"
              onClick={() => setEditing(true)}
            >
              ✏️ Editar Perfil
            </button>
          ) : (
            <>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleCancel}
                disabled={saving}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn-save"
                disabled={saving}
              >
                {saving ? (
                  <>
                    <div className="btn-spinner"></div>
                    Salvando...
                  </>
                ) : (
                  '💾 Salvar Alterações'
                )}
              </button>
            </>
          )}
        </div>
      </form>

      <div className="profile-info-box">
        <h4>ℹ️ Informações da Conta</h4>
        <div className="info-grid">
          <div className="info-item">
            <span className="info-label">Email:</span>
            <span className="info-value">{userProfile?.email || userEmail || 'N/A'}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Plano:</span>
            <span className="info-value">
              {userProfile?.subscription === 'business' && '💼 BUSINESS'}
              {userProfile?.subscription === 'pro' && '⭐ PRO'}
              {(userProfile?.subscription === 'none' || !userProfile?.subscription) && '🆓 FREE'}
            </span>
          </div>
          <div className="info-item">
            <span className="info-label">Membro desde:</span>
            <span className="info-value">
              {userProfile?.createdAt 
                ? new Date(userProfile.createdAt).toLocaleDateString('pt-BR')
                : 'N/A'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
